import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FAQS, BRAND } from "@/lib/constants";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="py-14 md:py-28">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="max-w-3xl animate-fade-up">
            <p className="text-xs uppercase tracking-[0.22em] text-[#28C0D8] font-semibold">
              FAQ
            </p>
            <h1 className="mt-4 font-display text-[32px] leading-[1.1] sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
              Frequently asked{" "}
              <span className="text-[#28C0D8]">questions.</span>
            </h1>
            <p className="mt-6 text-[17px] text-[#94A3B8] max-w-2xl">
              Everything you need to know before our launch in Bethesda,
              Maryland. Still curious? Give us a call at{" "}
              <a
                href={`tel:${BRAND.phoneRaw}`}
                className="text-[#28C0D8] hover:underline"
              >
                {BRAND.phone}
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 lg:px-14">
          <Accordion
            type="single"
            collapsible
            className="w-full divide-y divide-white/10 rounded-2xl border border-white/10 bg-[#13161C] overflow-hidden"
            data-testid="faq-accordion"
          >
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-none px-6 md:px-8"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left text-[17px] md:text-lg font-medium text-white hover:no-underline hover:text-[#28C0D8]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-relaxed text-[#94A3B8]">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section className="border-t border-white/5 bg-[#0A0B0E]">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 py-20 text-center">
          <h3 className="font-display text-3xl md:text-4xl font-semibold text-white tracking-tight">
            Didn&apos;t find your answer?
          </h3>
          <p className="mt-4 text-[#94A3B8]">
            We&apos;re happy to help — reach out any time.
          </p>
          <div className="mt-8 flex flex-col items-center sm:flex-row gap-3 justify-center">
            <Link
              to="/contact"
              className="btn-teal-glow inline-flex items-center justify-center gap-2 rounded-full bg-[#28C0D8] px-6 py-3 text-sm font-semibold text-[#0A0B0E] hover:bg-[#1FA8BC]"
            >
              Contact us <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={`mailto:${BRAND.email}`}
              className="inline-flex items-center justify-center rounded-full border border-white/15 px-6 py-3 text-sm text-white hover:bg-white/5"
            >
              {BRAND.email}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
